import React from 'react';
import './radioButton.css';

const RadioButton = props => (
  <div className="odsRadioButton_Wrapper">
    <div className="odsRadioButton_Container">
      <input
        className="odsRadioButton_RadioButton"
        type="radio"
        id={`odsRadioButton_${props.value}`}
        value={props.value}
        checked={props.stateValue === props.value}
        onChange={props.onChangeHandler}
      />
      <label className="odsRadioButton_Label" htmlFor={`odsRadioButton_${props.value}`}>
        {props.textValue}
      </label>
    </div>
  </div>
);

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/Form/radioButton.js